module.exports = __webpack_public_path__ + "img/picture.f971d22b.png";